import { useContext } from 'react';
import { useQueryClient, useMutation, useQuery } from 'react-query';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import createCachedSelector from 're-reselect';
import useToaster from '@ubeya/shared/hooks/useToaster';
import * as api from '../../services/api';
import useAccount from './useAccount';

const selector = createCachedSelector(
  (data) => data.data,
  (data) => {
    const modules = (data || []).reduce((prev, { slug }) => ({ ...prev, [slug]: true }), {});

    return { modulesData: data, modules };
  }
)({
  keySelector: (data, storeKey) => `${storeKey.join('#')}`
});

const useModules = () => {
  const { t } = useContext(ConfigContext);
  const { accountId } = useAccount();
  const queryClient = useQueryClient();

  const storeKey = ['modules', accountId];

  const { addSuccess, addResponseError } = useToaster();

  const { isLoading, isSuccess, data } = useQuery(storeKey, () => api.fetchActiveAccountModules({ accountId }), {
    enabled: !!accountId,
    select: (modulesApiData) => selector(modulesApiData, storeKey)
  });

  const { modulesData = [], modules = [] } = data || {};

  const { mutateAsync: updateModules } = useMutation(
    ({ modules: modulesUpdateData }) => api.updateModules({ accountId, modules: modulesUpdateData }),
    {
      onError: addResponseError,
      onSuccess: () => {
        queryClient.invalidateQueries(storeKey, { exact: true });
        addSuccess(t('updatedAccountModules'));
      }
    }
  );

  return { isLoading, isSuccess, modules, data: modulesData, updateModules };
};

export default useModules;
